export const ROLES = {
  super: "super",
  clinician: "clinician",
  viewer: "viewer",
} as const;

export const ROLES_AS_ARRAY = [ROLES.super, ROLES.clinician, ROLES.viewer] as const;

export type Role = keyof typeof ROLES;
